import { useQuery } from 'react-query';
import { delivererClient } from '../services/deliverer/DelivererClient';
import { ActiveWeeklyMenu } from '../services/deliverer/types';

const EMPTY_ACTIVE_WEEKLY_MENUS: ActiveWeeklyMenu[] = [];

export const useActiveWeeklyMenus = () => {
  const query = useQuery<ActiveWeeklyMenu[], Error>(
    ['activeWeeklyMenus'],
    async () => {
      const response = await delivererClient.getActiveWeeklyMenus();
      return response.weeklyMenus;
    },
    { staleTime: 1000 * 60 * 5, refetchOnWindowFocus: false }
  );

  return {
    activeWeeklyMenus: query.data ?? EMPTY_ACTIVE_WEEKLY_MENUS,
    loading: query.isLoading,
    error: query.isError
  };
};
